export function calculateCustomJobTotals(
  subtotal: number,
  discountAmount = 0,
) {
  const discount = Math.min(Math.max(0, discountAmount), subtotal);
  const total = Math.max(0, subtotal - discount);
  return {
    subtotal,
    discountAmount: discount,
    total,
  };
}
